<div
  class="tab-bar"
  [class.is-compact]="overflow === 'compact' && isCompact()"
  [ngClass]="{
    'variant-primary': variant === 'primary',
    'variant-secondary': variant === 'secondary',
    'variant-tertiary': variant === 'tertiary',
  }"
>
  <!-- Ghost that renders real hyperkit-tab instances at unconstrained width for measurement -->
  @if (overflow === 'compact') {
    <div #tabHeadersMeasure class="tab-headers-measure" aria-hidden="true">
      @for (tab of tabData; track tab.text) {
        <hyperkit-tab
          [variant]="variant"
          [mode]="mode"
          [text]="tab.text"
          [controlled]="true"
        ></hyperkit-tab>
      }
    </div>
  }

  <!-- Tab headers/navigation -->
  <div class="tab-headers">
    <ng-content select="hyperkit-tab"></ng-content>
  </div>

  <!-- Compact select (shown instead of tabs when overflowing) -->
  @if (overflow === 'compact' && isCompact()) {
    <div class="tab-select-compact">
      <hyperkit-select
        [ngModel]="selectedTabValue"
        [options]="tabSelectOptions"
        dropdownPosition="absolute"
        (ngModelChange)="onCompactSelectChange($event)"
      ></hyperkit-select>
    </div>
  }

  <!-- Tab content area (only for uncontrolled) -->
  @if (!controlled && selectedTab) {
    <div class="tab-content-container">
      @for (tab of tabs; track tab) {
        @if (tab === selectedTab) {
          <div class="tab-panel">
            <ng-container
              *ngTemplateOutlet="tab.contentTemplate"
            ></ng-container>
          </div>
        }
      }
    </div>
  }
</div>
